export enum PLACEHOLDER {
  CONTINUE_WATCHING = 'continueWatching',
  MISSED_SECTION = 'missedSection',
  TRENDING = 'trending',
  WATCHLIST = 'watchlist',
  BRANDS_SECTION = 'brandsSection',
  MOVIES_SECTION = 'moviesSection'
}
